import { api } from './api';

export type EmailStatus =
  | 'queued'
  | 'sent'
  | 'delivered'
  | 'bounced'
  | 'complained'
  | 'failed'
  | 'received';

export interface EmailMessageSummary {
  id: string;
  direction: 'outbound' | 'inbound';
  fromAddress: string;
  toAddresses: string[];
  ccAddresses: string[];
  subject: string;
  status: EmailStatus;
  sentAt: string | null;
  deliveredAt: string | null;
  bouncedAt: string | null;
  complaintAt: string | null;
  template: string | null;
  documentId: string | null;
  feeNoteId: string | null;
  sentByUserId: string | null;
  createdAt: string;
}

export interface EmailThread {
  id: string;
  chambersId: string;
  matterId: string | null;
  subject: string;
  createdAt: string;
  updatedAt: string;
  messages: EmailMessageSummary[];
}

export async function fetchEmailThreadsForMatter(matterId: string): Promise<EmailThread[]> {
  const res = await api.get(`/email/threads?matterId=${encodeURIComponent(matterId)}`);
  return res.data.data as EmailThread[];
}

export async function fetchEmailThreadsForChambers(): Promise<EmailThread[]> {
  const res = await api.get('/email/threads');
  return res.data.data as EmailThread[];
}

// ─── Synced (real inbox/sent) mail linked to a matter ──────────
// These are emails a barrister linked to the matter from the inbox
// (SyncedEmail.matterId) — distinct from the EmailThread delivery log above.

export interface MatterSyncedEmail {
  id: string;
  direction: 'inbound' | 'outbound';
  fromAddress: string;
  toAddresses: string[];
  subject: string;
  snippet: string | null;
  isRead: boolean;
  receivedAt: string | null;
  sentAt: string | null;
  linkStatus: string;
  attachmentCount: number;
}

export async function fetchMatterSyncedEmails(matterId: string): Promise<MatterSyncedEmail[]> {
  const res = await api.get(`/email/matter/${encodeURIComponent(matterId)}/synced`);
  return res.data.data as MatterSyncedEmail[];
}
